import { ActionType } from '@root/state/actions-types';
import { Action } from '@root/state/actions/settlement';

export type settlementList = {
  updatedAt: string | number | Date;
  key: React.Key;
  id: number;
  ReceiptID: string;
  issuingDate: string;
  Customer: string;
  Country: string;
  Amount: string;
  Status: string;
  Fee: string;
};

export type settlementLists = {
  count: number;
  rowData: settlementList[];
};

export interface settlementListState {
  loading: boolean;
  error: string | null;
  data: settlementLists;
}

const initialSettlementState: settlementListState = {
  loading: false,
  error: null,
  data: { count: 0, rowData: [] }
};

export const settlementReducer = (
  state: settlementListState = initialSettlementState,
  action: Action
): settlementListState => {
  switch (action.type) {
    case ActionType.GET_SETTLEMENT_LIST:
      return {
        ...initialSettlementState,
        loading: true,
        error: null,
        data: { count: 0, rowData: [] }
      };

    case ActionType.GET_SETTLEMENT_LIST_SUCCESS:
      return {
        ...initialSettlementState,
        loading: false,
        error: null,
        data: action.payload
      };

    case ActionType.GET_SETTLEMENT_LIST_ERROR:
      return {
        ...initialSettlementState,
        loading: false,
        error: action.payload,
        data: { count: 0, rowData: [] }
      };
    default:
      return state;
  }
};

export type settlementAmountInfo = {
  totalAmount: number;
  monthlyAmount: number;
  balanceAmount: number;
};

export interface settlementAmountInfoState {
  error: string | null;
  amount: { data: settlementAmountInfo };
}

const initialSettlementAmountInfoState: settlementAmountInfoState = {
  error: null,
  amount: {
    data: {
      totalAmount: NaN,
      monthlyAmount: NaN,
      balanceAmount: NaN
    }
  }
};

export const amountInfoReducer = (
  state: settlementAmountInfoState = initialSettlementAmountInfoState,
  action: Action
): settlementAmountInfoState => {
  switch (action.type) {
    case ActionType.GET_AMOUNT_INFO_SUCCESS:
      return {
        ...initialSettlementAmountInfoState,
        error: null,
        amount: { data: action.payload }
      };
    case ActionType.GET_AMOUNT_INFO_ERROR:
      return {
        ...initialSettlementAmountInfoState,
        error: action.payload,
        amount: {
          data: {
            totalAmount: NaN,
            monthlyAmount: NaN,
            balanceAmount: NaN
          }
        }
      };
    default:
      return state;
  }
};

export interface infor {
  id: number;
  name: string;
  country: string;
  countryCode: string;
  phoneNumber: string;
  detailAddress: string;
  email: string;
}
export const info: infor = {
  id: NaN,
  name: '',
  country: '',
  countryCode: '',
  phoneNumber: '',
  detailAddress: '',
  email: ''
};
export type billingInquiryDetail = {
  id: number;
  seller: infor;
  admin: infor;
  warehouse: infor;
  periodStart: string;
  periodEnd: string;
  numberProductTypes: number;
  orderCounts: number;
  numberDelivered: number;
  numberReturn: number;
  numberDisposal: number;
  billingAmount: string;
  billingStatus: string;
  receiptId: string;
  paypalApproveUrl: string;
  serviceStatus: string;
  paypalOrderId: string;
  billingInquiryFile: {
    created_at: string;
    updated_at: string;
    id: number;
    url: string;
    key: string;
    fileName: string;
  };
  serviceAmount?: string;
};

export interface billingInquiryDetailState {
  loading: boolean;
  error: string | null;
  detail: billingInquiryDetail;
}

const initbillingInquiryDetail = {
  id: NaN,
  seller: info,
  warehouse: info,
  admin: info,
  periodStart: '',
  periodEnd: '',
  numberProductTypes: NaN,
  orderCounts: NaN,
  numberDelivered: NaN,
  numberReturn: NaN,
  numberDisposal: NaN,
  billingAmount: '',
  billingStatus: '',
  receiptId: '',
  serviceStatus: '',
  paypalApproveUrl: '',
  paypalOrderId: '',
  billingInquiryFile: {
    created_at: '',
    updated_at: '',
    id: NaN,
    url: '',
    key: '',
    fileName: ''
  }
};

const initialBillingInquiryDetail: billingInquiryDetailState = {
  loading: false,
  error: null,
  detail: initbillingInquiryDetail
};

export const billingInquiryDetailReducer = (
  state: billingInquiryDetailState = initialBillingInquiryDetail,
  action: Action
): billingInquiryDetailState => {
  switch (action.type) {
    case ActionType.GET_BILLING_INQUIRY_DETAIL:
      return {
        ...initialBillingInquiryDetail,
        loading: true,
        error: null,
        detail: initbillingInquiryDetail
      };
    case ActionType.GET_BILLING_INQUIRY_DETAIL_SUCCESS:
      return {
        ...initialBillingInquiryDetail,
        loading: false,
        error: null,
        detail: action.payload
      };

    case ActionType.GET_BILLING_INQUIRY_DETAIL_ERROR:
      return {
        ...initialBillingInquiryDetail,
        loading: false,
        error: action.payload,
        detail: initbillingInquiryDetail
      };
    default:
      return state;
  }
};

export type customerInfoListType = {
  companyAddress: string;
  companyCountryCode: string;
  companyPhoneNumber: string;
  country: string;
  email: string;
  id: number;
  name: string;
};

export type customerListState = {
  loading: boolean;
  error: string | null;
  customerLists: infor[];
};

const initialCustomerInfoList: customerListState = {
  loading: false,
  error: null,
  customerLists: []
};

export const customerInfoListReducer = (
  state: customerListState = initialCustomerInfoList,
  action: Action
): customerListState => {
  switch (action.type) {
    case ActionType.GET_CUSTOMER_INFO:
      return {
        ...initialCustomerInfoList,
        loading: true,
        error: null,
        customerLists: []
      };
    case ActionType.GET_CUSTOMER_INFO_SUCCESS:
      return {
        ...initialCustomerInfoList,
        loading: false,
        error: null,
        customerLists: action.payload
      };
    case ActionType.GET_CUSTOMER_INFO_ERROR:
      return {
        ...initialCustomerInfoList,
        loading: false,
        error: action.payload,
        customerLists: []
      };
    default:
      return state;
  }
};

export type inquiryInboundInfo = {
  numberDelivered: number;
  numberDisposal: number;
  numberProductTypes: number;
  numberReturn: number;
  orderCounts: number;
  warehouse: infor;
};

export type inquiryInboundInfoState = {
  loading: boolean;
  error: string | null;
  info: inquiryInboundInfo;
};

const initInfo: inquiryInboundInfo = {
  numberDelivered: NaN,
  numberDisposal: NaN,
  numberProductTypes: NaN,
  numberReturn: NaN,
  orderCounts: NaN,
  warehouse: info
};
const initialInquiryInboundInfo: inquiryInboundInfoState = {
  loading: false,
  error: null,
  info: initInfo
};

export const inquiryInboundInfoReducer = (
  state: inquiryInboundInfoState = initialInquiryInboundInfo,
  action: Action
): inquiryInboundInfoState => {
  switch (action.type) {
    case ActionType.GET_INQUIRY_INBOUND_INFO:
      return {
        ...initialInquiryInboundInfo,
        loading: true,
        error: null,
        info: initInfo
      };
    case ActionType.GET_INQUIRY_INBOUND_INFO_SUCCESS:
      return {
        ...initialInquiryInboundInfo,
        loading: false,
        error: null,
        info: action.payload
      };

    case ActionType.GET_INQUIRY_INBOUND_INFO_ERROR:
      return {
        ...initialInquiryInboundInfo,
        loading: false,
        error: action.payload,
        info: initInfo
      };

    default:
      return state;
  }
};

export type billingInquiry = {
  sellerId: number;
  periodStart: string;
  periodEnd: string;
  numberProductTypes: number;
  orderCounts: number;
  numberDelivered: number;
  numberReturn: number;
  numberDisposal: number;
  billingAmount: number;
  billingInquiryFileId: number;
};

export type billingInquiryState = {
  loadingCreate: boolean;
  error: string | null;
  bodyBillingInquiry: billingInquiryDetail;
};

const initialBillingInquiry: billingInquiryState = {
  loadingCreate: false,
  error: null,
  bodyBillingInquiry: initbillingInquiryDetail
};

export const createBillingInquiryReducer = (
  state: billingInquiryState = initialBillingInquiry,
  action: Action
): billingInquiryState => {
  switch (action.type) {
    case ActionType.POST_BILLING_INQUIRY:
      return {
        ...initialBillingInquiry,
        loadingCreate: true,
        error: null,
        bodyBillingInquiry: initbillingInquiryDetail
      };

    case ActionType.POST_BILLING_INQUIRY_SUCCESS:
      return {
        ...initialBillingInquiry,
        loadingCreate: false,
        error: null,
        bodyBillingInquiry: action.payload
      };
    case ActionType.POST_BILLING_INQUIRY_ERROR:
      return {
        ...initialBillingInquiry,
        loadingCreate: false,
        error: action.payload,
        bodyBillingInquiry: initbillingInquiryDetail
      };
    default:
      return state;
  }
};
